<template>
  <div class="v-containers" v-resize="calculateComponentHeight">
    <v-container>
      <v-row>
        <v-col>
          <span class="tx-1 tx-dark-gray tx-b-700">
            Poznaj nas bliżej!
          </span>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <span class="tx-3 tx-dark-gray tx-b-700">
            Zarząd firmy
          </span>
        </v-col>
      </v-row>
    </v-container>

    <v-container fluid class="management-content">
      <div
        class="management-content__tiles-background"
        :style="componentHeight ? `height: ${componentHeight}px;` : ''"
      >
        <v-img
          height="100%"
          width="100%"
          src="@/assets/photos/management-component-bg.webp"
        ></v-img>
        <div class="management-content__v-img-filter"></div>
      </div>

      <div class="management-content__tiles">
        <v-container>
          <v-row justify="center" dense>
            <v-col :cols="colsTakenByTile">
              <div class="tile">
                <div class="tile__tile-label">
                  <div class="tile-label__icon" :style="getTileIconStyle">
                    <font-awesome-icon
                      :icon="['fas', 'user-tie']"
                    ></font-awesome-icon>
                  </div>
                  <div class="tile-label__function">Prezes Zarządu</div>
                  <div class="tile-label__name">Paweł Nowak</div>
                </div>
              </div>
            </v-col>
          </v-row>
          <v-row justify="center" dense>
            <v-col :cols="colsTakenByTile">
              <div class="tile">
                <div class="tile__tile-label">
                  <div class="tile-label__icon" :style="getTileIconStyle">
                    <font-awesome-icon
                      :icon="['fas', 'user-tie']"
                    ></font-awesome-icon>
                  </div>
                  <div class="tile-label__function">
                    Wiceprezes Zarządu
                  </div>
                  <div class="tile-label__name">Paweł Seryło</div>
                </div>
              </div>
            </v-col>
            <v-col :cols="colsTakenByTile">
              <div class="tile">
                <div class="tile__tile-label">
                  <div class="tile-label__icon" :style="getTileIconStyle">
                    <font-awesome-icon
                      :icon="['fas', 'user-tie']"
                    ></font-awesome-icon>
                  </div>
                  <div class="tile-label__function">
                    Wiceprezes Zarządu
                  </div>
                  <div class="tile-label__name">Tomasz Nowak</div>
                </div>
              </div>
            </v-col>
          </v-row>
        </v-container>
      </div>
    </v-container>
  </div>
</template>

<script>
export default {
  name: "management-component",
  props: ["colsTakenByTile"],
  data: function() {
    return {
      observedElements: [],
      overflowOfTiles: null,
      componentHeight: null
    };
  },
  mounted() {
    this.calculateComponentHeight(true);
    this.$emit("loading-finished");
  },
  updated() {
    this.calculateComponentHeight();
  },
  methods: {
    calculateComponentHeight(onMounted) {
      // console.log("calculateComponentHeight()");
      const tilesBackground = document.getElementsByClassName(
        "management-content__tiles-background"
      )[0];
      const tiles = document.getElementsByClassName(
        "management-content__tiles"
      )[0];
      if (onMounted && tiles && tilesBackground) {
        const interval = setInterval(() => {
          this.componentHeight = tiles.offsetHeight;
          if (
            tiles.offsetHeight === tilesBackground.offsetHeight &&
            tilesBackground.offsetHeight !== 0
          ) {
            clearInterval(interval);
          }
        }, 100);
      } else if (tiles) {
        this.componentHeight = tiles.offsetHeight;
      } else {
        this.componentHeight = null;
      }
    }
  },
  computed: {
    getTileIconStyle: function() {
      return this.$vuetify.breakpoint.xsOnly ? "margin-bottom: -6px;" : "";
    },
    loggedIn: function() {
      return this.$store.state.authentication.loggedIn;
    }
  }
};
</script>

<style lang="scss" scoped>
.management-content__v-img-filter {
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
  background-color: #0c9a9a;
  mix-blend-mode: hue;
}

.management-content {
  padding: 0;
  margin: 0;
  position: relative;
  top: 0;
}

.management-content__tiles {
  width: 100%;
  position: absolute;
  top: 0;
}

.tiles {
  width: 100%;
  position: absolute;
  top: 0;
}

.tile {
  width: 100%;
  height: 0;
  padding-bottom: 100%;
  background-color: #e9e9e9;
  position: relative;
  top: 0;
}

.tile__tile-label {
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.tile-label__icon {
  color: #4a4a4a;
  font-size: 48px;
  margin-bottom: 12px;
}

.tile-label__function {
  color: #4a4a4a;
  font-size: 16px;
  font-weight: 500;
  text-align: center;
  margin-bottom: 6px;
}
.tile-label__name {
  color: #4a4a4a;
  text-align: center;
}
</style>
